<template>
    <AppHeader v-if="!ehRotaEbook" />

    <router-view />

    <AppFooter v-if="!ehRotaEbook" />

    <a
        v-if="!ehRotaEbook"
        href="#"
        class="back-to-top"
    >
        <i class="icofont-simple-up"></i>
    </a>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
    components: {
        AppHeader,
        AppFooter,
    },

    setup() {
        const route = useRoute();
        const ehRotaEbook = computed(() => route.name === 'ebook-reforma-tributaria');

        return {
            route,
            ehRotaEbook,
        };
    },
};
</script>

<style scoped></style>